import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CreditCard, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function CardWelcome() {
  const { user } = useAuth();
  const [show, setShow] = useState(false);
  useEffect(() => { if (user && !localStorage.getItem(`rl_card_welcome_${user.id}`)) setShow(true); }, [user]);
  if (!show) return null;
  const close = () => { localStorage.setItem(`rl_card_welcome_${user.id}`, "1"); setShow(false); };
  return (
    <div className="rl-card border-[#FF9F0A]/60 p-5 mb-6 relative" data-testid="card-welcome">
      <button onClick={close} className="absolute top-3 right-3 text-slate-500 hover:text-white p-1" aria-label="Chiudi" data-testid="card-welcome-close"><X className="w-4 h-4" /></button>
      <div className="pill-badge pill-amber mb-2"><CreditCard className="w-3 h-3" /> LA TUA RALLY LOVE CARD È ATTIVA</div>
      <p className="text-sm text-slate-300 mb-3">Partecipa alle attività, vivi i rally e accumula vantaggi esclusivi.</p>
      <Link to="/card" onClick={close} className="btn-crimson !py-2 !px-5 text-xs min-h-[44px] inline-flex items-center" data-testid="card-welcome-cta">SCOPRI I TUOI VANTAGGI</Link>
    </div>
  );
}
